export enum RoutesEnum {
  HOME = '/home',
  CHAT = '/chat',
  LOGIN = '/login',
  PRIVACY_POLICY = '/privacy-policy'
}
